<template>
  <div class="personal">
    <div class="p-account">
      <!-- <header>
        <div class="g-header" style="background: rgb(70, 105, 154)">
          <div class="left"></div>
          <div class="middle fs-18"></div>
          <div class="right" @click="changestting(1)">
            <div class="bg-icon bg-icon-setting"></div>
          </div>
        </div>
        <div class="blockHeight"></div>
      </header> -->
      <div class="tit_box">个人中心</div>
      <div class="user_box">
        <img :src="getAvatarUrl(user.avatar)" class="avatar" alt="" />
        <div class="user_msg">
          <span style="margin-bottom: 2px;">用户名称: {{ user.username }}</span>
          <span style="margin-top: 2px;">用户id: {{ user.user_id }}</span>
        </div>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="mescroll p-account_scroll">
          <div>
            <div class="scroll-content">
              <!-- <div class="cont-head">
                <div class="user-head">
                  <div class="user-avatar" @click="changebaseinfo">
                    <img src="@/assets/image/auth.png" class="avatar" alt="" />
                  </div>
                  <div class="grade-box">
                    <div class="member-benefit">
                      <img
                        src="@/assets/image/vip.png"
                        class="icon icon-vip-equity"
                        alt=""
                      />
                      <span>{{ $t('huiyuanquanyi') }}</span>
                    </div>
                    <div class="nickName">
                      <span>{{ user.username }}</span>
                      <img
                        src="@/assets/image/vip1.png"
                        class="icon-vip-grade"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div> -->
              <div class="cont-box">
                <div class="asset">
                  <div class="asset-item">
                    <span>我的资金</span>
                    <span class="item_money">￥ {{ user.money }}</span>
                  </div>
                  <div class="asset-item">
                    <span>今日回款</span>
                    <span class="item_money">￥ {{ Math.abs(user.today_approved_withdraw) }}</span>
                  </div>
                  <div class="asset-item">
                    <span>审核金额</span>
                    <span class="item_money">￥ {{ Math.abs(user.today_pending_withdraw) }}</span>
                  </div>
                </div>
                <ul class="tx-box">
                                    <li class="tx" @click="changeRecharge">
                    
                    <span class="text">充值</span>&nbsp;&nbsp;
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA8CAMAAADsSTwRAAAAh1BMVEUAAAAMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIMkvIp3H48AAAALHRSTlMAumYFgoyWvYZ0qwof3ZAPec7Eon1gWCgi7uGkMxgD/erTp2xROp9GQwbFMB+INhEAAAGcSURBVFjD7ZdZcoMwDEAVkhgTwk4g+7619f3P11q0MRgnjDX9SZv3JTzoDTICBLzopAznwpogLJsWLojwuoUJMsxsoXs8UZH2rEhFhfetCaoqI7Ak4tVGAzLBgxgIxJg6wditKiSBu+piOJPhkqZZytwZhhsZRjRNJHM3GMpoDkSw92+aoEckaGjo/H1N4BDRtrgPJPrif2iO4VAn5CVUjHmIC/mqQ8OEkYN6J1WUDzVTYWYHkkQthA81Y2EmAUmqFoakohyQFGph2rHFF84HGjz/SVrlHBc8/7n65tc0x9hTxIVP0kwSoRF3at5aGlPjXMGMk3j+navhBs3IbGHqM7vARq9p3mXafnRjj9/D+5WsMD59eQ51zcL4JJiIGt186kNdczI+CSZ8IRmDQmlMMxcDggY+mFsjza6GeuJ9lp23MuOcLbKjrllbNG3rem0HE0foYGm2Y1LR0uBttx7amKkowghZyLcXbnE+4ANVA2Gg1W64xXjtji73NJbDPmtpaJ51UzOFNtxGs8ZDn/Rb5hbq5MNObHN48Yx8Apyc8XJZLKfhAAAAAElFTkSuQmCC" class="icon" alt="" />
                  </li>
                  <li class="tx" @click="changeWithdraw">
                    
                    <span class="text">提现</span>&nbsp;&nbsp;
                    <img
                      src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAA8CAMAAADsSTwRAAABGlBMVEUAAAAMkPEMkvIMkvIMkfIMkvIMkvMMkvILkvMLkvILkvIMkvMLkvMLkvIMkfMEjPAMkvILkvKU2/8MkvIMkvIMkvMMkfELkvMMkvQMkvKL2P8KkfEMkvMLkfEMk/MMkvMMk/MLkvIMkvIMk/MLkfIMk/INkvQMkvELkvILkfELk+8Pk/ANk/ELk/EMk/EMkvQLkvILkPIMkvIMkfILkvIMkvMMkfEKlvELkfOM2v8MkfOM2v8Kj+8NkfIInPWX3v8LjvMMkvIKkO8IjOyJ1/8LnfOK2P+R3P8LfvSI1/8BivMOjfOL2f8QkPaa4f+L2P8Mk/WX4P+V4P+k6v8JkPIKkvCL1f8MkvKK2P8Mk/MLkvEMkPIMlvINm/F+/ggAAAAAV3RSTlMAge0Hnvge6gWX+ysgqhuChAlyccW7rqZfRDEtJBXw6OLd18p7c2lnTUkzMQPPwLWajoh+eVxYPzgr/rumo4doZFMnEPDNy6Wim5mIf3M/MykoHhsLCwpO6XaBAAACN0lEQVRYw93WaVPaUBSA4cNOQGMoe9n3pSAoCKh1777vR5L2//+N5rS5yRWNJjc6o76fcmeYZw4ngQk8gErdTicf9YgklArq1ZsJL0q4hkbVYw9fqIpWm3NRZrhErt9v1oSUHFLZ3iyLlPYn5BPYdcCPegpdLtL4v1rONXOo0T1ik7FlpxfuFJkUdW7OpsQMKCi7YTKkjMCqmDWcctP5ihZIjAx8+YaqIlWfOWXqdG/ew0rtCltR35GyQ8pLuFySPZLjm1b0JTfOhIhpHEqrKdMUW7V/nZXJTnuDFaT03Hx2NQ0dV2sBX7xKikipn5ZyVkbhNi3G+kahm7rsfGRKeKnSeLNCoSiHr08uFuKsQi9NTIwxbToNQaB11GOHMR26IkyB7iw7bNFoYREmWuamadJuZboKJBIBJ9HnQG9QQVwyxkfTrNFYEb/jItIAIBq5gkm6ewYnNkzGHZO2YfLoqhMbBnrSQdBhB1IXbBiX3SVT9Mxso57smTnRr1MDzwx0GpkSeGeoR8fEp8e3wPT3UJO8MwrqlW6HKd6r39SDYXafUp93jaej/0yvH3fJ/No/N3r1DeDHCI2GYVfMh3Oz1wAbKmOWWVfMW4vZB3in8q8kAZ6ZECPbbuaFyXwCOPWbTh4AKhwjod4p2PX96Mm/jr7SSW63knqtNu34LISoXfgT3QaBdvgXk/xS8M1kXuaZRASp1FbTd2UbRr4LTZQRUg1+NvHiYBZURZG9DnC1YiKGqvpzcA/7Cz4QZ+4ysajqAAAAAElFTkSuQmCC"
                      class="icon"
                      alt=""
                    />
                  </li>

                </ul>
                <ul class="list-box">
                  <li class="list" @click="changePersonalCenter">

                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAAflBMVEUAAAB3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqqN6geEAAAAKXRSTlMAynAlDAeAPBjWsnlE7rmlk4tVSR8T9fHnmzQF4t7NxL+FaWMuWVCqXbcejdIAAAGZSURBVDjLbVPZtoIwEBsQyo6AIqDghqL5/x+8ZWmHXskDpzOkkzQFYuyiOxZY4kUbOO8BhKIvil6MyzT+odiyW3B5CIHcZJQ3WJ7Z2t3RrgX9E28yRp914SQoaAMecFTrAAd+cXFXeqgu8+oBwfM7oBaa9ka4kC1tPQBudyDREuFsKcVOyQTISyLXRu2rFoJpzE1teqJRJ8pUL0M8utHBXKGMJCctPzpqE1JgYyEfugMRGuZcNzi51IGtORYc1lIYJAFvXfbYzwuBh26+kNPomwfl8tCOjdbhu0RmcC7hmGEFqySDY1xneYVEvYTKWk+uMwBBAGDPvRgRreylqL9HOX24ItCGIhyo6lT14ageHKcFlxoVVyz7Gns8V8F6SjzAyqp7qtT1fuWzxWUsnHEMo8FrSdwdNeZBBzVd7Y/mxN/LceKJIyvGMHGO6JT25MRzzP9Wlm6lPZ4Bnzbg1vzDSB14v5RdbVj0wF8wB4zB3HNDFa0N2S26M/1DkQB34fmO43tRCqCnDfQpNCzbpW2Uhcg+n0Z8zWP+AbTBKJSDUNZOAAAAAElFTkSuQmCC" alt="" class="icon-liebiao">
                    <div class="list-text">账号信息</div>
                    <img src="@/assets/image/you.png" class="arrow" alt="" />
                  </li>
                  <li class="list" @click="changeBet">
                                       <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAMAAABgOjJdAAAAclBMVEUAAABxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZxfaZQYl8ZAAAAJXRSTlMAvwIn+uIvVkKHDCPE9beOhnpnUxvd2NFDFxKloZk766uEb1E0en7YdwAAALpJREFUOMvNz8kOgjAUheEDqJS2zKDMjuf9X1GaEAJB68YF3/rPzT2YhMTKhRIzJaoGJSFFJSYFIkophIeR25JMcSZyztqxQEZSK3Ou8/PaFNKfKXOjyf2AoQQ7jEyxErHBKGMCFtZPqUEFI42x8ujdufBg4dLZVzGUx40yWxZVeNhK97jlH0Vxj5NgksSJ2hY5V7JtAe+05O5zrfpZ1LChBn1YFLyBHPCVuvKFJ61SAHXsaOcj7fQn4A23uxuUxBX5JAAAAABJRU5ErkJggg==" alt="" class="icon-liebiao">
                    <div class="list-text">交易明细</div>
                    <img src="@/assets/image/you.png" class="arrow" alt="" />
                  </li>
                  <li class="list" @click="changeCapitalDetail">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAAXVBMVEUAAABnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tnc5tlzF4nAAAAHnRSTlMA3BPlTDsh4KGRV/HSzsSwPQW8mEY2HBYJ6MFqQS7R9qm+AAAAmElEQVQ4y+3TyQ6DIBSF4YsDKKKCdeh43v8xC+KCpEKbNGlc9Fvdxb88l35rrBWLUJVckxOSBuMSNc5ZxDINuBKBUVIPSSjTTYaWkNlj0bp8decuauCbCrty17Ct4cWuKWiivmrOXb6pEo1gKxE0cf/mWI3boX6754/+ooa4PTjnM3mGh2SLjshGaOyeROGbOg9cgN7Q0TwBtQgRx4xHeJQAAAAASUVORK5CYII=" alt="" class="icon-liebiao">
                    <div class="list-text">充值记录</div>
                    <img src="@/assets/image/you.png" class="arrow" alt="" />
                  </li>
                  <li class="list" @click="changeWithdrawRecord">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAe1BMVEUAAABwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6Nwe6MoKZvwAAAAKHRSTlMADKOqn/IGs1WYThrtY/rmysC6kDrh3dGIfxII011JQyjXdzByIINnJYFkAgAAAVBJREFUOMt90tmygjAQBNAmrBEFQRZBwN3b//+FdwKIpYLnIVCVrqlhBnzxOltj0eGoKLyF29Yn6VY7BvgWBjbJXGcSZIoPdWtHZBIc0DsTbwKfRuFUe8cWKmYij+o01j6TdAVfxvcKwipoX60ZdRv1zf4xwYIjczmVxJb0A7G5whKXB6nwI7Cm9zsQvwL17PRzyuH3TYbl/e2q2xikzEq7HQTjGhMr4dooz7xgVDG38HRhhoFPdJfHXlQRyxAjFeO4gXEiGk62GDlbcChydXFLfUNFXB+nCgUedt1XiDC6MXp9h6Y3dYNgd4Igr5hkZOqnabrTPCOhaSdcZ297TJumKUtS11BsTeCOGQXHdWceZuXPXWytn4EOcYhZBQ/DD9PEwWq1+k65psKeSlJbkeFDyMgMk2wxS3bqDDNk7OyE1trpKcNJyGJoflNylqvM/T9YaiUrNm4H4gAAAABJRU5ErkJggg==" alt="" class="icon-liebiao">
                    <div class="list-text">提现记录</div>
                    <img src="@/assets/image/you.png" class="arrow" alt="" />
                  </li>
                  <li class="list" @click="changeLoginPassword">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAYFBMVEUAAAB5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKtdogqZAAAAH3RSTlMAbhVz8oz54tO5QOiQTMa9pp2DZmAvKMl9VzUQrZIGF+LCLQAAAL1JREFUOMvFkNsWgiAQRQdBQMH7LbM6//+X2aqVgooPPbTfzrBhmKE1WSIAc0tpn1QBubUDoDva4QL1uTpKNHvn8RIqMPK44r6OJfwuSrjZGO+DyMKFCuQhc7eD8oUCWz/0pjgVCl+wi/DIOIdg3IFpcD5G74FmJBy+pfa1wqGLDujL2VCSAmgQbEhoQKjPhNip1KUT2UbQOBES8X+hEL9OkbW+cL7JMiRwUIIoIEhDk4FlB9QSPdFU4BDd0xPQuRMrb6M8SQAAAABJRU5ErkJggg==" alt="" class="icon-liebiao">
                    <div class="list-text">登录密码</div>
                    <img src="@/assets/image/you.png" class="arrow" alt="" />
                  </li>
                  <li class="list" @click="changeSecurityPassword">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAYFBMVEUAAAB5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKt5hKtdogqZAAAAH3RSTlMAbhVz8oz54tO5QOiQTMa9pp2DZmAvKMl9VzUQrZIGF+LCLQAAAL1JREFUOMvFkNsWgiAQRQdBQMH7LbM6//+X2aqVgooPPbTfzrBhmKE1WSIAc0tpn1QBubUDoDva4QL1uTpKNHvn8RIqMPK44r6OJfwuSrjZGO+DyMKFCuQhc7eD8oUCWz/0pjgVCl+wi/DIOIdg3IFpcD5G74FmJBy+pfa1wqGLDujL2VCSAmgQbEhoQKjPhNip1KUT2UbQOBES8X+hEL9OkbW+cL7JMiRwUIIoIEhDk4FlB9QSPdFU4BDd0xPQuRMrb6M8SQAAAABJRU5ErkJggg==" alt="" class="icon-liebiao">
                    <div class="list-text">安全密码</div>
                    <img src="@/assets/image/you.png" class="arrow" alt="" />
                  </li>
                  <li class="list" @click="changeRouteLogin">
                    <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAjCAMAAAApB0NrAAAAflBMVEUAAAB3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqp3gqqN6geEAAAAKXRSTlMAynAlDAeAPBjWsnlE7rmlk4tVSR8T9fHnmzQF4t7NxL+FaWMuWVCqXbcejdIAAAGZSURBVDjLbVPZtoIwEBsQyo6AIqDghqL5/x+8ZWmHXskDpzOkkzQFYuyiOxZY4kUbOO8BhKIvil6MyzT+odiyW3B5CIHcZJQ3WJ7Z2t3RrgX9E28yRp914SQoaAMecFTrAAd+cXFXeqgu8+oBwfM7oBaa9ka4kC1tPQBudyDREuFsKcVOyQTISyLXRu2rFoJpzE1teqJRJ8pUL0M8utHBXKGMJCctPzpqE1JgYyEfugMRGuZcNzi51IGtORYc1lIYJAFvXfbYzwuBh26+kNPomwfl8tCOjdbhu0RmcC7hmGEFqySDY1xneYVEvYTKWk+uMwBBAGDPvRgRreylqL9HOX24ItCGIhyo6lT14ageHKcFlxoVVyz7Gns8V8F6SjzAyqp7qtT1fuWzxWUsnHEMo8FrSdwdNeZBBzVd7Y/mxN/LceKJIyvGMHGO6JT25MRzzP9Wlm6lPZ4Bnzbg1vzDSB14v5RdbVj0wF8wB4zB3HNDFa0N2S26M/1DkQB34fmO43tRCqCnDfQpNCzbpW2Uhcg+n0Z8zWP+AbTBKJSDUNZOAAAAAElFTkSuQmCC" alt="" class="icon-liebiao">
                    <div class="list-text">切换账号</div>
                    <img src="@/assets/image/you.png" class="arrow" alt="" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
    <tab-bar></tab-bar>
  </div>
</template>
<script>
import TabBar from "@/components/tabbar/TabBar.vue";
import userApi from "@/api/user";
import storeAction from "@/store/typed-actions";
import { handleUnauthorizedError } from "@/utils/auth";
export default {
  name: "Personal",
  components: {
    TabBar,
  },
  data() {
    return {
      isLoading: false,
      user: "",
    };
  },
  methods: {
    // 获取头像URL，为接口返回的路径添加域名
    getAvatarUrl(avatar) {
      if (!avatar) {
        return require('@/assets/image/auth.png');
      }
      
      // 如果已经是完整的URL（包含http或https），直接返回
      if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
        return avatar;
      }
      
      // 如果是相对路径，添加API域名
      const baseURL = 'https://admin.banbashop.cc';
      return baseURL + (avatar.startsWith('/') ? avatar : '/' + avatar);
    },
    onRefresh() {
      this.$toast.loading({
        message: this.$t('jiazaizhong'),
        forbidClick: true,
        duration: 0,
      });
      userApi.userInfo().then((data) => {
        // 检查返回的code是否为401，如果是则跳转到登录页
        if (handleUnauthorizedError(data)) {
          return;
        }
        
        console.log(data.msg);
        this.user = data.msg;
        storeAction.setCurrentUserMoney(data.msg.money);
         storeAction.setCurrentUserGroup_id(data.msg.group_id);
        storeAction.setsessionStorage("money", data.msg.money);
        storeAction.setsessionStorage("group_id", data.msg.group_id);
        storeAction.setsessionStorage("idcard", data.msg.idcard);
          storeAction.setCurrentUserusercrud(data.msg.idcard);
        this.isLoading = false;
        this.$toast.clear();
      }).catch((error) => {
        // 处理网络错误等情况
        this.isLoading = false;
        this.$toast.clear();
        this.$toast.fail('网络错误，请稍后重试');
        console.error('获取用户信息失败:', error);
      });
    },
    changestting(type) {
      this.$router.push({
        path: "/setting",
        query: {
          type: type,
        },
      });
    },
    changebaseinfo() {
      this.$router.push({
        path: "/baseinfo",
        query: {
          name: this.user.username,
        },
      });
    },
    changePersonalCenter() {
      this.$router.push({
        path: "/personalCenter",
      });
    },
    changeActionCenter() {
      this.$router.push({
        path: "/actionCenter",
      });
    },
    changeShareFriend() {
      this.$router.push({
        path: "/shareFriend",
      });
    },
    changeNotice() {
      this.$router.push({
        path: "/Notice",
      });
    },
    changeBet() {
      this.$router.push({
        path: "/BetRecord",
      });
    },
    changeCapitalDetail() {
      this.$router.push({
        path: "/CapitalDetail",
      });
    },
    changeWithdrawRecord() {
      this.$router.push({
        path: "/WithdrawRecord",
      });
    },
    changeWithdraw() {
      // 先检查是否已设置安全密码
      userApi.safetyInfo().then((res) => {
        if (res.code === 1) {
          // 判断是否已设置安全密码
          if (!res.data.isTrue) {
            // 未设置安全密码，提示用户
            this.$dialog.alert({
              title: '提示',
              message: '请先设置安全密码再进行提现操作',
            }).then(() => {
              // 跳转到设置安全密码页面
              this.$router.push('/setSecurityCode?isTrue=false');
            });
            return;
          }
          
          // 已设置安全密码，继续检查是否绑定银行卡
          userApi.withdrawInfo().then((res) => {
            if (res.code === 1) {
              // 判断 pay_list 是否为空
              if (!res.data.pay_list || res.data.pay_list.length === 0) {
                // 未绑定银行卡，直接跳转到添加银行卡页面，不提示
                this.$router.push('/newWithdraw');
              } else {
                // 已绑定银行卡，继续提现流程
                this.$router.push({
                  path: "/Withdraw",
                  query: {
                    group_id: this.user.group_id,
                  },
                });
              }
            } else {
              this.$toast.fail(res.msg || '获取提现信息失败');
            }
          }).catch((error) => {
            this.$toast.fail('网络错误，请稍后重试');
            console.error('获取提现信息失败:', error);
          });
        } else {
          this.$toast.fail(res.msg || '获取安全密码信息失败');
        }
      }).catch((error) => {
        this.$toast.fail('网络错误，请稍后重试');
        console.error('获取安全密码信息失败:', error);
      });
    },
    changeRecharge() {
      this.$router.push({
        path: "/Recharge",
        query: {
          group_id: this.user.group_id,
        },
      });
    },
    changego() {
      this.$router.go(-1);
    },
    changeRouteLogin() {
      let that = this;
      storeAction.clearCurrentUserId();
      storeAction.clearToken();
      storeAction.delsessionStorage("id");
      storeAction.delsessionStorage("userId");
      storeAction.delsessionStorage("money");
      storeAction.delsessionStorage("idcard");
      storeAction.delsessionStorage("group_id");
      storeAction.setCurrentUserMoney(null);
      this.$toast.loading({
        message: this.$t('jiazaizhong'),
        forbidClick: true,
        duration: 500,
        onClose() {
          that.$router.push(`/login`);
        },
      });
    },
    changeLoginPassword() {
      this.$router.push({
        path: "/changePassword"
      });
    },
    changeSecurityPassword() {
      // 根据pass_code判断跳转路径
      if (this.user.pass_code === 0) {
        // 未设置安全密码，跳转到设置页面
        this.$router.push({
          path: "/setSecurityCode",
          query: {
            isTrue: false
          }
        });
      } else if (this.user.pass_code === 1) {
        // 已设置安全密码，跳转到修改页面
        this.$router.push({
          path: "/setSecurityCode",
          query: {
            isTrue: true
          }
        });
      }
    },
  },
  created() {
    this.onRefresh();
  },
};
</script>
<style lang="less" scoped>
.personal {
  height: 100%;
}
.tit_box {
  width: 100%;
  background-color: #161936;
  padding: 15px;
  font-size: 18px;
  text-align: center;
}
.user_box {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 0;
  padding-left: 10px;
  .user_msg {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    font-size: 15px;
    margin-left: 10px;
  }
}
.p-account {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  // background: linear-gradient(to bottom, #46699a 80%, #040925 0%);
  height: 100%;
}
.bg-icon-setting {
  background: url("../assets/image/shezhi.png");
  background-size: 60%;
  width: 1.35rem;
  height: 1.35rem;
}
.bg-icon {
  width: 0.68rem;
  height: 0.68rem;
  margin-left: 0.1rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.mescroll {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-box-flex: 1;
  flex: 1;
  /* 移动端滚动优化 */
  -webkit-overflow-scrolling: touch;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}
.scroll-content {
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  padding-bottom: 1rem;
  padding-bottom: calc(1rem + constant(safe-area-inset-bottom));
  padding-bottom: calc(1rem + env(safe-area-inset-bottom));
}
.cont-head {
  padding-bottom: 0.8rem;
}
.user-head {
  text-align: center;
}
.user-avatar {
  position: relative;
  display: inline-block;
}
.avatar {
  width: 1.46rem;
  height: 1.46rem;
  border-radius: 50%;
  object-fit: cover;
}
.grade-box {
}
.member-benefit {
  margin: 0.16rem 0;
  display: inline-block;
  span {
    color: #fff;
    font-size: 0.4rem;
  }
}
.icon-vip-equity {
  width: 0.5rem;
  height: 0.4rem;
  margin-right: 0.08rem;
}
.nickName {
  font-size: 0.4rem;
  color: #fff;
}
.icon-vip-grade {
  margin-left: 5px;
  width: 1rem;
}
.cont-box {
  background: #040925;
  padding-bottom: 0.4rem;
  flex: 1;
  /* 移动端渲染优化 */
  position: relative;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}
.asset {
  display: flex;
  padding: 0.2rem 0;
  border-radius: 4px;
  background-color: #1a243f;
  text-align: center;
  margin: 0 0.2rem;
  min-height: 2.2rem;
  border-radius: .3rem;
  /* 移动端滚动修复 */
  position: relative;
  z-index: 1;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
  will-change: transform;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.asset-item {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  position: relative;
  // border-right: 1px solid #3d5179;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  span {
    font-size: 0.38rem;
  }
  .item_money {
    color: #2978e5;
  }
}
.asset .asset-item span:first-child {
  margin-bottom: 0.2rem;
  font-size: 0.35rem;
  color: #d3d3d9;
}
.tx-box {
  margin: 0.26rem;
  padding: 0.3rem 0;
  border-radius: 10px;
  background: #1a243f;
}
.tx-box,
.tx {
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.p-account .tx-box .tx:first-child {
  border-right: 1px solid #3d5179;
}
.tx {
  width: 50%;
}
.text {
  margin-left: 0.32rem;
  font-size: 0.35rem;
}
.list-box {
  border-radius: 0.1rem;
  background: #1a243f;
  margin: 0 0.2rem;
  padding: 0 0.24rem 0 0.3rem;
}
.list {
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.5rem 0 0.35rem;
  border-bottom: 1px solid #3d5179;
}
.list-text {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  text-align: left;
  font-size: 0.35rem;
}
.arrow {
  width: 0.2rem;
  height: 0.4rem;
}
.icon-liebiao {
  width: 0.4rem;
  height: 0.4rem;
  margin-right: .2rem;
}
.p-account .list-box .list:last-child {
  border-bottom: none;
}
</style>